import MuiRadio, { RadioProps } from '@mui/material/Radio';
import { useCallback } from 'react';

export type IRadioProps = Omit<RadioProps, 'name' | 'value' | 'onChange'> & {
    name: string;
    readOnly?: boolean;
    onChange?: (value: boolean) => void;
};

export const Radio = ({ disabled, readOnly, onChange, checked, ...rest }: IRadioProps) => {
    const handleChange = useCallback(() => {
        if (onChange && !readOnly && !disabled) {
            onChange(!checked);
        }
    }, [disabled, checked, readOnly, onChange]);

    return (
        <MuiRadio
            {...rest}
            disabled={disabled || readOnly}
            checked={checked}
            readOnly={readOnly}
            onChange={handleChange}
        />
    );
};
